<nav
  class="sidenav-container"
  [class.sidenav-container-collapsed]="!isOpen"
  appUserManual
  [userManualKey]="'side-navigation'"
>
  @if (isOpen) {
    <div class="sidenav-expanded">
      <!-- Selector chips — each is its own independent card -->
      @if (isOnline) {
        <div class="selector-card">
          <app-project-selector></app-project-selector>
        </div>
      }
      @if (displayTaskFilter) {
        <div class="selector-card">
          <app-task-selector></app-task-selector>
        </div>
      }
      @if (displaySiteFilter) {
        <div class="selector-card">
          <app-site-selector></app-site-selector>
        </div>
      }

      <!-- Tree — its own card, fills remaining space -->
      <div class="tree-card">
        <app-tree></app-tree>
      </div>

      <!-- Collapse button below the tree card -->
      <div class="footer">
        <button
          type="button"
          class="collapse-button"
          cdkMonitorElementFocus
          (click)="toggleOpen()"
          title="Collapse menu"
          aria-label="Collapse menu"
        >
          <i class="material-icons">zoom_in_map</i>
        </button>
      </div>
    </div>
  } @else {
    <div class="footer footer-collapsed">
      <button
        type="button"
        class="collapse-button"
        cdkMonitorElementFocus
        (click)="toggleOpen()"
        title="Expand menu"
        aria-label="Expand menu"
      >
        <i class="material-icons">zoom_out_map</i>
      </button>
    </div>
  }
</nav>
